<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAudioTransmission_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m17.782 15.11-1.128-1.128a5.4 5.4 0 0 0 1.255-1.764q.455-1.018.455-2.163 0-1.146-.455-2.146a5.4 5.4 0 0 0-1.255-1.745L17.783 5A7.3 7.3 0 0 1 19.4 7.273q.6 1.309.6 2.782 0 1.472-.6 2.781a7.3 7.3 0 0 1-1.618 2.273m-2.328-2.328-1.163-1.164q.327-.31.527-.7t.2-.863-.2-.864a2.6 2.6 0 0 0-.527-.7l1.163-1.164q.582.527.91 1.228.327.699.327 1.5 0 .8-.327 1.5a3.8 3.8 0 0 1-.91 1.227m-5.636.182q-1.2 0-2.054-.855a2.8 2.8 0 0 1-.855-2.054q0-1.2.855-2.055a2.8 2.8 0 0 1 2.054-.855q1.2 0 2.055.855.854.855.854 2.055t-.854 2.054-2.055.855M4 18.782v-2.037q0-.6.31-1.127.308-.527.854-.8a11.4 11.4 0 0 1 2.09-.8q1.164-.327 2.564-.327t2.564.327 2.09.8q.547.273.855.8.31.528.31 1.127v2.037z"
    />
</svg>
